import lfRequest from '@/service/index'

export function getListByRole(roleId: string) {
  return lfRequest.get<any[]>({
    url: `/main/permission/role/${roleId}`
  })
}
